module.exports = __webpack_public_path__ + "img/collection-weddingRingsBlack.6110848.jpg";